import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconFiles, IconFolders } from '@tabler/icons-react';
import { lazy } from 'react';

/**
 * Бутстрап модуля FileManager (клиент)
 * Регистрирует навигацию через рантайм.
 */
export async function setup(app: AppRuntime) {
  const filemanager = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
    // Сразу после доменных модулей (crm 10, procurement 15, mws/accounting 20),
    // выше служебного хвоста с дефолтным весом
    navigationOrder: 21,
  });

  filemanager.useNavigation([
    {
      // Техсписок всех загруженных файлов: из меню скрыт (юзерам достаточно
      // Диска), роут жив — прямые ссылки и админский разбор работают
      icon: IconFiles,
      label: 'File Manager',
      url: '/filemanager',
      component: lazy(() => import('./components/UploadedFilesList')),
      hiddenFromMenu: true,
    },
    {
      icon: IconFolders,
      label: 'Диск',
      url: '/filemanager/drive',
      component: lazy(() => import('./components/drive/DrivePage')),
    },
    {
      // Стенд встраиваемых компонентов Диска (панель папки, модалка поиска):
      // нужен разработчику для проверки на живых данных, юзерам — нет
      icon: IconFolders,
      label: 'Диск — стенд',
      url: '/filemanager/test_page',
      component: lazy(() => import('./components/drive/DriveTestPage')),
      hiddenFromMenu: true,
    },
  ]);
}
